import { Tag } from 'antd';

// const PaymentStatus = {
//   PENDING: 'pending',
//   PAID: 'paid',
//   REFUND: 'refund',
// };

// export const paymentStatus = Object.keys(PaymentStatus).map((key) => ({
//   value: PaymentStatus[key],
//   label: key,
// }));

export const paymentStatus = [
  { value: 'pending', label: 'Non Payé' },
  { value: 'paid', label: 'Payé' },
  { value: 'refund', label: 'Remboursé' },
];

export const getTagPaymentStatus = (record) => {
  switch (record.pay_status) {
    case 'pending':
      return <Tag color="gold">Non Payé</Tag>;
    case 'deposited':
      return <Tag color="green">Deposited</Tag>;
    case 'paid':
      return <Tag color="blue">Payé</Tag>;
    default:
      return <Tag color="purple">Remboursé</Tag>;
  }
};

export const payMethod = [
  {
    value: 'om',
    label: 'OM',
  },
  {
    value: 'wave',
    label: 'Wave',
  },
  {
    value: 'agent',
    label: 'Agent',
  },
  {
    value: 'kpay',
    label: 'Kpay',
  },
  {
    value: 'cash',
    label: 'Cash',
  },
];
